export enum FlatFeeType {
  CUSTOM = 'Custom',
  COUNTY_FEE = 'County Fee',
  WRIT_FEE = 'Writ Filing Fee',
  SHERIFF_FEE = 'Sheriff Fee',
  HEARING_FEE = 'Hearing Fee',
  CLIENT_ATTORNEY_FEE = 'Attorney Fee'
}
